import * as React from 'react';
import Logo from "../../app/components/integra-logo.png"
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, FormHelperText, InputLabel, CircularProgress, FormControl, InputAdornment, IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { connect } from "react-redux";
import { verifyAccount } from '../../app/store/actions/authActions';
import { Navigate, NavLink, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { centered_flex_box, MainInput, MainInputLabel, MainPassword, main_button, StyledInput, SecInput } from '../../app/components/Styles';
import { Image } from 'antd';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

export const VerifyAccount = ({ verifyAccount, user, authToken, isLoading }) => {

    const { token } = useParams()
    const navigate = useNavigate()
    const currentLocale = Cookies.get("login.i18next") || "en";
    const { t, i18n } = useTranslation();

    if (user) {
        try {
            window.ReactNativeWebView.postMessage(authToken);
        } catch (err) {
            console.log(err)
        }
        return (<Navigate to={`/`} replace />)
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        var details = {
            passcode: data.get('passcode'),
            token
        }
        verifyAccount(details)
    };

    if (isLoading) {
        return (
            <Box sx={{ ...centered_flex_box }}>
                <CircularProgress sx={{ color: "var(--secColor)" }} />
            </Box>
        )
    }

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: "100%",
                    paddingTop: 3
                }}
            >
                <Image preview={false} src={Logo} height="100px" width="227px" />
                <Box sx={{ ...centered_flex_box, mt: 2, flexDirection: "column", p: 5 }}>
                    <Typography fontSize={30} fontWeight="bold" textAlign="center" color={"var(--primaryPurple)"}>{t("login.verify_account")}</Typography>
                    <hr style={{ width: "50%", opacity: "100%", "border-top": "solid var(--primaryPurple) 3px" }} />
                </Box>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <MainInput
                        margin="normal"
                        sx={{ my: 1 }}
                        required
                        fullWidth
                        name="passcode"
                        label={t("login.passcode")}
                        type='number'
                        inputProps={{ inputMode: 'numeric', pattern: '^[0-9]{6,6}$' }}
                        id="passcode"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, ...main_button }}
                    >
                        {t("login.verify")}
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    authToken: state?.auth?.token,
    isLoading: state?.auth?.isLoading,
});

const mapDispatchToProps = { verifyAccount };

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);